import { IToastMessage, ToastLevel } from './IToastMessage';

export class ToastMessage implements IToastMessage {
    constructor(private el: HTMLDivElement) {
        const startTimer = window.setTimeout(() => {
            this.el.classList.add('transition');
            window.clearTimeout(startTimer);
        }, 1000)
    }

    private timer: number = 0;

    public toast(level: ToastLevel, message: string): void {
        // console.info(`toasting ${level} with message ${message}`);
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.el.textContent = message;
        this.el.classList.add('show');
        this.timer = window.setTimeout(() => {
            this.el.classList.remove('show')
            this.timer = 0;
        }, 2000)
    }
}